import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import apiLmsManager from '../../services/apiLmsManager';

const TIPOS_STAFF_ESCOLA = ['ADM_ESCOLA', 'FUNCIONARIO_ESCOLA'];
const STORAGE_RECUSADO = '@RockspotIpRecusado';
const DIAS_SEM_PERGUNTAR = 7;

// Uma checagem por carregamento do admin, não a cada troca de página.
let _checado = false;

function recusouRecentemente(ip) {
  try {
    const recusado = JSON.parse(localStorage.getItem(STORAGE_RECUSADO) || 'null');
    return Boolean(recusado && recusado.ip === ip && recusado.ate > Date.now());
  } catch (e) {
    return false;
  }
}

function registraRecusa(ip) {
  try {
    localStorage.setItem(
      STORAGE_RECUSADO,
      JSON.stringify({ ip, ate: Date.now() + DIAS_SEM_PERGUNTAR * 24 * 60 * 60 * 1000 })
    );
  } catch (e) {}
}

/**
 * Mantém o IP da escola atualizado para a restrição do Rockspot: quando um
 * funcionário da escola entra no admin de um IP desconhecido, pergunta se está
 * na escola e, se estiver, cadastra o IP.
 */
function RockspotIpCheck() {
  const [status, setStatus] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    if (_checado || !TIPOS_STAFF_ESCOLA.includes(localStorage.getItem('@RockfellerType'))) return;
    _checado = true;

    apiLmsManager
      .get('/rockspot/minha-escola/ip-status')
      .then(({ data }) => {
        if (data.aplicavel && !data.conhecido && data.ip_atual && !recusouRecentemente(data.ip_atual)) {
          setStatus(data);
        }
      })
      .catch(() => {});
  }, []);

  if (!status) return null;

  async function confirma() {
    setSalvando(true);
    setErro(null);
    try {
      await apiLmsManager.post(`/rockspot/escola/${status.escola_id}/ips`);
      setStatus(null);
    } catch (e) {
      setErro(e.response?.data?.message || 'Não foi possível cadastrar o IP.');
    } finally {
      setSalvando(false);
    }
  }

  function recusa() {
    registraRecusa(status.ip_atual);
    setStatus(null);
  }

  return (
    <Dialog open onClose={recusa} maxWidth="sm" fullWidth>
      <DialogTitle>Você está na escola agora?</DialogTitle>
      <DialogContent>
        <p>
          Esta conexão (IP <strong>{status.ip_atual}</strong>) ainda não está cadastrada como rede da{' '}
          <strong>{status.escola_nome}</strong>.
        </p>
        <p>
          Se você está na escola, confirme para os alunos continuarem entrando no Rockspot pelos computadores daqui.
          Se está em casa ou em outro lugar, responda que não.
        </p>
        {erro && <p className="text-danger">{erro}</p>}
      </DialogContent>
      <DialogActions>
        <button type="button" className="btn btn-default border-radius" onClick={recusa} disabled={salvando}>
          Não estou na escola
        </button>
        <button type="button" className="btn primary border-radius" onClick={confirma} disabled={salvando}>
          {salvando ? 'Salvando...' : 'Sim, estou na escola'}
        </button>
      </DialogActions>
    </Dialog>
  );
}

export default RockspotIpCheck;
